import Button from "../Button/Button"
import Title from "../Title/Title"

function Industries() {
  return (
    <article className="flex px-6 sm:px-5 xl:px-16 3xl:px-24 py-8 sm:py-16 bg-[--color-blue] relative">
      <div className="flex absolute left-0 top-8 sm:top-16 w-full sm:w-[calc(100%-6rem)] h-[calc(100%-2rem)] sm:h-[calc(100%-8rem)] bg-white"></div>
      {/* Responsive grid: 1 column on mobile, 2 on large screens */}
      <div className="grid grid-cols-1 lg:grid-cols-2 py-12 sm:py-24 bg-white px-0 sm:pe-5 xl:pe-16 3xl:pe-24 w-full relative z-20 gap-8 lg:gap-20 3xl:gap-80">
        {/* Sticky section in first column, sticky only on lg+ */}
        <div className="lg:sticky lg:top-64 h-fit mb-2  xl:mb-12 lg:mb-0 p-6">
          <div className="flex flex-col gap-6 sm:gap-9">
            <Title
              title="Industries"
              type="h2"
              className="uppercase text-[24px] xl:text-[60px] 2xl:text-[72px]"
            />

            <p className="text-base sm:text-lg 2 ">
              Frequent changes in the regulatory framework and dynamics of the
              volatile services industry require security and IT systems that
              enable adaptability, optimization, realignment, consolidation
              continuously. With our vast experience in studying security
              challenges, current and futuristic needs, organizational
              efficiency and effectiveness, regulatory obligations of financial
              institutions, we offer a wide spectrum of solutions and services
              respective of industry domain that make a definite business
              impact. <br />
              <br />
              We assist financial services to evolve unique solutions specific
              to their needs and environment, and do away with existing
              implementations that are generic, ineffective, compromising, rigid
              and expensive. <br />
              <br />
              CyberStone works with its clients to make the right technology
              investments by bringing leading-edge insight, experienced
              professionals, and a rigorous process to every project. We have
              accumulated the best practices for the respective industries. Our
              consultants are knowledgeable of the markets and environment in
              respective industries and provide the best services through their
              extensive experience:
            </p>
            <Button type="three" title="Enquire now" url="/contact" icon />
          </div>
        </div>
        {/* Main content in second column */}
        <div className="flex flex-col">
          <div className="w-full lg:w-full gap-9 xl:grid grid-cols-2">
            <div className="bg-[--color-dark] relative w-full h-[200px] xl:h-[300px] 2xl:h-[500px] hover:bg-[--color-brand] transition-all duration-300 ease-in-out overflow-hidden mb-4 lg:mb-0">
              <Title
                title="Industries"
                type="h4"
                className="uppercase text-[24px] xl:text-[34px] 2xl:text-[48px] text-white p-6"
              />
              <img
                src="/ind-tech.png"
                alt="Technology industry cybersecurity"
                width={300}
                height={300}
                loading="lazy"
                decoding="async"
                className="w-[150px] 2xl:w-[300px] absolute bottom-0 right-0"
              />
            </div>
            <div className="bg-[--color-dark] relative w-full h-[200px] xl:h-[300px] 2xl:h-[500px] hover:bg-[--color-brand] transition-all duration-300 ease-in-out overflow-hidden mb-4 lg:mb-0">
              <Title
                title="finance"
                type="h4"
                className="uppercase text-[24px] xl:text-[34px] 2xl:text-[48px] text-white p-6"
              />
              <img
                src="/ind-finance.png"
                alt="Finance industry cybersecurity"
                width={300}
                height={300}
                loading="lazy"
                decoding="async"
                className="w-[150px] 2xl:w-[300px] absolute bottom-0 right-0"
              />
            </div>
            <div className="bg-[--color-dark] relative w-full h-[200px] xl:h-[300px] 2xl:h-[500px] hover:bg-[--color-brand] transition-all duration-300 ease-in-out overflow-hidden mb-4 lg:mb-0">
              <Title
                title="healthcare"
                type="h4"
                className="uppercase text-[24px] xl:text-[34px] 2xl:text-[48px] text-white p-6"
              />
              <img
                src="/ind-health.png"
                alt="Healthcare industry cybersecurity"
                width={300}
                height={300}
                loading="lazy"
                decoding="async"
                className="w-[150px] 2xl:w-[300px] absolute bottom-0 right-0"
              />
            </div>
            <div className="bg-[--color-dark] relative w-full h-[200px] xl:h-[300px] 2xl:h-[500px] hover:bg-[--color-brand] transition-all duration-300 ease-in-out overflow-hidden mb-4 lg:mb-0">
              <Title
                title="telecom"
                type="h4"
                className="uppercase text-[24px] xl:text-[34px] 2xl:text-[48px] text-white p-6"
              />
              <img
                src="/ind-tel.png"
                alt="Telecom industry cybersecurity"
                width={300}
                height={300}
                loading="lazy"
                decoding="async"
                className="w-[150px] 2xl:w-[300px] absolute bottom-0 right-0"
              />
            </div>
            <div className="bg-[--color-dark] relative w-full h-[200px] xl:h-[300px] 2xl:h-[500px] hover:bg-[--color-brand] transition-all duration-300 ease-in-out overflow-hidden mb-4 lg:mb-0">
              <Title
                title="oil & gas"
                type="h4"
                className="uppercase text-[24px] xl:text-[34px] 2xl:text-[48px] text-white p-6"
              />
              <img
                src="/ind-oil.png"
                alt="Oil and gas industry cybersecurity"
                width={300}
                height={300}
                loading="lazy"
                decoding="async"
                className="w-[150px] 2xl:w-[300px] absolute bottom-0 right-0"
              />
            </div>
            <div className="bg-[--color-dark] relative w-full h-[200px] xl:h-[300px] 2xl:h-[500px] hover:bg-[--color-brand] transition-all duration-300 ease-in-out overflow-hidden mb-4 lg:mb-0">
              <Title
                title="industrial"
                type="h4"
                className="uppercase text-[24px] xl:text-[34px] 2xl:text-[48px] text-white p-6"
              />
              <img
                src="/ind-industrial.png"
                alt="Industrial sector cybersecurity"
                width={300}
                height={300}
                loading="lazy"
                decoding="async"
                className="w-[150px] 2xl:w-[300px] absolute bottom-0 right-0"
              />
            </div>
          </div>
        </div>
      </div>
    </article>
  )
}

export default Industries
